import React from 'react';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import GetOptions from './GetOptions';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const accountColumnDefs = permissions => [
  {
    Header: 'Account',
    accessor: 'account',
    Cell: cellInfo => (
      <AccountLinkCell dataKey="itemId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-20p'
  },
  {
    Header: 'Legal Entity',
    accessor: 'legalEntityName',
    className: 'col-20p'
  },
  {
    Header: 'Parent Account',
    accessor: 'parentAccountName',
    className: 'col-20p'
  },
  {
    Header: 'Financial Account?',
    accessor: 'isFinancialAccount',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isFinancialAccount'),
    className: 'col-20p'
  },
  {
    Header: 'Is Active?',
    accessor: 'isActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-15p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default accountColumnDefs;
